function getContextFromPath(): string {
  const { pathname } = window.location;
  const contexts = ['mets-tescucha', 'fix-tescucha', 'tescucha'];
  const currentContext = contexts.find(context => pathname.includes(context));
  return currentContext || 'tescucha';
}

export const PREFIX_STORE = getContextFromPath();

const localStorageConstants = {
  token: `${PREFIX_STORE}_TOKEN`,
};

export const addToLocalStorage = (key: string, value = '') => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key: string) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : '';
};

export const removeFromLocalStorage = (key: string) => localStorage.removeItem(key);

export default localStorageConstants;
